import React, { Component } from 'react';
import {
	ResponsiveContainer, Tooltip, Legend, CartesianGrid, XAxis, YAxis,
	LineChart, Line, ReferenceLine, 
	Brush
} from 'recharts';
import BlockUi from 'react-block-ui';
import chartUtils, { COLORS } from '../../home/utils';
import ValueModeSwitch from '../../home/ValueModeSwitch';
import { withTranslation } from 'react-i18next';

const ValueMode = {
	AMOUNT: 'amount',
	COUNT: 'count'
};

class LessonPaymentsRevenue extends Component {
	constructor(props) {
		super(props);
		this.handleModeChange = this.handleModeChange.bind(this);
		this.state = {
			mode: ValueMode.COUNT
		};
	}

	handleModeChange(mode) {
		this.setState({ mode });
	}

	render() {
		const { loading, data, referenceLinesX, height = 300, t } = this.props;
		const { mode } = this.state;
		const timeSeriesChartMargin = { top: 10, right: 30, left: 0, bottom: 0 };

		return <BlockUi blocking={loading}>
			<ValueModeSwitch selectedMode={mode} onChange={this.handleModeChange} modes={[/*{ value: ValueMode.AMOUNT, label: t('SalesDashboard_Amount') },*/ { value: ValueMode.COUNT, label: t('SalesDashboard_Count') }]} /> 
			<ResponsiveContainer height={height}>				
				<LineChart data={chartUtils.prepareTimeSeriesData(data)} margin={timeSeriesChartMargin}>
					<XAxis dataKey='timestamp' scale='time' type='number' domain={['dataMin', 'dataMax']} tickFormatter={chartUtils.formatUnixTime} />
					<YAxis axisLine={false} tickLine={false} />
					<CartesianGrid vertical={false} />
					<Tooltip labelFormatter={label => chartUtils.formatUnixTime(label, 'll')} />
					{referenceLinesX && data && data.length > 1 && referenceLinesX.map((line, index) => <ReferenceLine key={index} x={chartUtils.convertToUnixTime(line.value)} label={line.label} />)}
					{ValueMode.AMOUNT === mode && <Line type='monotone' dot={false} name={t('SalesDashboard_DailyRevenue')} dataKey='value' stroke={COLORS[0]} />}
					{ValueMode.COUNT === mode && <Line type='monotone' dot={false} name={t('SalesDashboard_DailyCount')} dataKey='count' stroke={COLORS[0]} />}
					<Brush height={25} />
				</LineChart>
			</ResponsiveContainer>
		</BlockUi>;
	}
}

export default withTranslation()(LessonPaymentsRevenue);